import React,{useState,useRef} from "react";
import "./style.css";
import {useNavigate} from "react-router-dom";
import {Modal, Button} from "react-bootstrap"
import {UrlBaseServer} from "../../../Services/storageServer";
import {useAuth} from "../../../Services/auth";
import {useQuery} from "react-query";
import api from "../../../Services/api"
import visaCard from "./../../../Assets/visaLogo.png"

import data from "bootstrap/js/src/dom/data";
import {generateSlug} from "../../../Services/tools";
const BottomBtn = ({product, update, showModal, setShowModal, setShowModalBoost, showModalBoost,priceChoosed}) => {
  const navigate = useNavigate();
  const handleClose = () =>  navigate("/product-detail/"+product.id,{});
  const handleShow = () => setShowModal(true);
  const handleCloseBoost = () => setShowModalBoost(false)
    const [CBChoosed, setCBChoosed] = useState(0);
    const [paiementId, setPaiementId] = useState(null);
    const [webPaiementUrl, setWebPaiementUrl] = useState(null);
    const [webPaiementVisible, setWebPaiementVisible] = useState(null);
    const {user} = useAuth()
    const { isLoading,
        isError,
        error,
        data:dataCard,
        isFetching,
        isPreviousData, } = useQuery(['repoCard'], ()=> api.getCards(),{ keepPreviousData : true }
    )
    React.useEffect(()=>{
        if(dataCard){
            findIndexOnArray()
        }
    },[dataCard])
    async function payedBoost() {
        //cardSelected({ selectedCardId: cards[CBChoosed].Id });

        const boostData = await api.postBoost(
            [product],
            priceChoosed.index,
            dataCard?.data[CBChoosed].Id
        );
        console.log(boostData);
        setPaiementId(boostData.data.data.Id);
        if (boostData.data.data.SecureModeNeeded) {
            setWebPaiementUrl(boostData.data.data.SecureModeRedirectURL);
            setWebPaiementVisible(true);
        }
        if (boostData.data.data.Status == "SUCCEEDED") {
            navigate("/user-profile",{})
            //setModalBoostOk(true);
            //setModalValidateVisible(true);
        }
    }
    async function findIndexOnArray() {
        // let cardId = await AsyncStorage.getItem("cardID");
        let cardId = user.selectedCardId;
        let cardIndex = dataCard?.data?.findIndex((object) => {
            return object.Id === cardId;
        });

        if (cardIndex == -1) {
            cardIndex = 0;
        }
        setCBChoosed(cardIndex);
    }
    return (
    <div>
      <div className="text-center mb-5">
        <button onClick={()=>window.history.back()} type="button" className="btn1 mx-4 mb-2">
          Annuler
        </button>
        {update?(<button
            type="submit"
            className="btn2 mb-2"
            //data-toggle="modal"
            //data-target="#exampleModalCenter"
        >
          Modifier
        </button>):(<button
            type="submit"
            className="btn2 mb-2"
            //data-toggle="modal"
            //data-target="#exampleModalCenter"
        >
          Ajouter
        </button>)}

      </div>

      <Modal show={showModal} onHide={handleClose} animation={false}>
        {update?(<div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="edit-model">
              <p className="edit-modal-title">Bouteille Mise à jour</p>
              <p className="edit-modal-description">
                Votre annonce a été mise à jour et sera visible par les autres membres dans quelques
                minutes. Vous avez la possibilité de booster votre annonce
                depuis la rubrique ma cave à tout moment.
              </p>
              <div className="modal-btn-box">
                <button className="btn2 mb-2" onClick={()=>{
                  navigate("/detail-produit/"+generateSlug(product.name)+"_"+product.id,{})
                }} >Voir mon annonce</button>
                <button onClick={()=>{
                  navigate("/user-profile",{})
                }} className="btn1">Voir ma cave</button>
              </div>
            </div>
          </div>
        </div>):(
            <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="edit-model">
              <p className="edit-modal-title">Bouteille Mise En Ligne</p>
              <p className="edit-modal-description">
                Votre annonce sera visible par les autres membres dans quelques
                minutes. Vous avez la possibilité de booster votre annonce
                depuis la rubrique ma cave à tout moment
              </p>
              <div className="modal-btn-box">
                <button className="btn2 mb-2" onClick={()=>{
                  navigate("/detail-produit/"+generateSlug(product.name)+"_"+product.id,{})
                }} >Voir mon annonce</button>
                <button onClick={()=>{
                  navigate("/edit-bottle",{})
                }} className="btn1">Ajouter une autre Bouteille</button>
              </div>
            </div>
          </div>
        </div>
        )}

      </Modal>

        <Modal show={showModalBoost} onHide={handleCloseBoost} animation={false}>
            <div className=" modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="edit-model">
                        <p className="edit-modal-title">Boost</p>
                        <div style={{display:"flex"}}>
                            <img style={{width:100, height:100, objectFit:"cover"}} src={UrlBaseServer+product?.Product_images[0]?.image} />
                            <div style={{display:"flex", marginLeft:10, flexDirection:"column", justifyContent:"space-between"}}>
                            <div style={{color:"grey"}}>
                                {product?.year}
                                {" " + product?.Region?.name + " "}
                                {product?.Appelation?.name}
                            </div>
                            <div>
                                {product?.name}
                            </div>
                            <div style={{fontWeight:800}}>
                                {product?.price} €
                            </div>
                            </div>
                        </div>
                        <hr/>
                        <div style={{fontWeight:800}}>
                            Boost pour {priceChoosed?.days} jours choisi
                        </div>
                        <div>
                            Montant à payer: <span style={{fontWeight:800}}>{priceChoosed?.price} €</span>
                        </div>
                        <hr/>
                        <div>
                            <h5>Adresse</h5>
                            <div style={{display:"flex", alignItems:"center"}}>
                                {user.Addresses?.length > 0 ? (
                                    <div style={{ flex: 1 }}>
                                        <div
                                            style={{

                                                fontWeight: "600",
                                            }}
                                        >
                                            {user.Addresses[0].firstName + " " + user.Addresses[0].lastName}
                                        </div>
                                        <div
                                            style={{

                                            }}
                                        >
                                            {user.Addresses[0].number +
                                            " " +
                                            user.Addresses[0].address +
                                            " " +
                                            user.Addresses[0].additional_address}
                                        </div>
                                        <div
                                            style={{
                                            }}
                                        >
                                            {user.Addresses[0].postal_code +
                                            " " +
                                            user.Addresses[0].city +
                                            " " +
                                            user.Addresses[0].country}
                                        </div>
                                    </div>
                                ) : (
                                    <div>Indiquez votre adresse</div>
                                )}
                                <i className="fa-solid fa-pen-to-square" style={{marginRight:5, cursor:"pointer", fontSize:24}}/>
                            </div>
                        </div>
                        <hr/>
                        <div>
                            <h5>Paiement</h5>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                            {dataCard?.data?.length ? (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <img
                                        style={{
                                            width: 50,
                                            height: 35,
                                            resizeMode: "contain",
                                        }}
                                        src={visaCard}
                                    />
                                    <div
                                        style={{
                                            marginLeft: 16,
                                            flex: 1,
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontWeight: "300",
                                            }}
                                        >
                                            {dataCard?.data[CBChoosed]?.CardProvider + " se terminant par "}
                                            <div
                                                style={{
                                                    fontWeight: "700",
                                                }}
                                            >
                                                {dataCard?.data[CBChoosed]?.Alias.substr(
                                                    dataCard?.data[CBChoosed]?.Alias?.length - 4
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                fontWeight: "300",
                                            }}
                                        >
                                            Date d’expiration :{" "}
                                            {dataCard?.data[CBChoosed]?.ExpirationDate[0] +
                                            "" +
                                            dataCard?.data[CBChoosed]?.ExpirationDate[1]}
                                            /
                                            {dataCard?.data[CBChoosed]?.ExpirationDate.substr(
                                                dataCard?.data[CBChoosed]?.ExpirationDate?.length - 2
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>Pas de carte enregistré</div>
                            )}
                            <i className="fa-solid fa-pen-to-square" style={{marginRight:5, cursor:"pointer", fontSize:24}}/>
                            </div>
                        </div>
                        <div style={{marginTop:30}} className="modal-btn-box">
                            <button className="btn2 mb-2" onClick={()=>{
                                console.log("paiement")
                                payedBoost();
                            }} >Valider le paiement</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>

      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="edit-model">
              <p className="edit-modal-title">Bouteille Mise En Ligne</p>
              <p className="edit-modal-description">
                Votre annonce sera visible par les autres membres dans quelques
                minutes. Vous avez la possibilité de booster votre annonce
                depuis la rubrique ma cave à tout moment
              </p>
              <div className="modal-btn-box">
                <button className="btn2 mb-2">voir mon annonce</button>
                <button className="btn1">Ajouter une autre Bouteille</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BottomBtn;
